import { render, staticRenderFns } from "./ScrollWinners.vue?vue&type=template&id=5f2102cb"
import script from "./ScrollWinners.vue?vue&type=script&lang=js"
export * from "./ScrollWinners.vue?vue&type=script&lang=js"
import style0 from "./ScrollWinners.vue?vue&type=style&index=0&id=5f2102cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports